import app from '../../app';
import { Config } from '@cian/config';
import { Store } from 'redux';
import { IAppState } from '../../../../../shared/redux';
import { selectIsNewPublishTermsEnabled } from '../../../../../shared/selectors/publishTerms';
import { getPublishTermsInfo } from '../../../../../shared/services/publishTerms';
import { IHttpApi } from '@cian/http-api/shared';
import { loadPublishTerms, setIsNewPublishTermsEnabled } from '../../../../../shared/redux/reducers';
import { IRootScopeService } from 'angular';

// При добавлении новых инжектов, не забудь добавить сервис в конец файла!
export function publishTermsService(
  store: Store<IAppState>,
  config: Config,
  httpApi: IHttpApi,
  $rootScope: IRootScopeService,
) {
  const isNewPublishTermsEnabled = () => {
    const state = store.getState();

    return selectIsNewPublishTermsEnabled(config, state);
  };

  const getPublishTermsType = async (locationPathRaw: Array<number> | undefined) => {
    const locationPath = (locationPathRaw || []).join(',');

    const { isNewPublishTerms } = await getPublishTermsInfo({ httpApi, locationPath });

    store.dispatch(setIsNewPublishTermsEnabled(isNewPublishTerms));

    if (isNewPublishTermsEnabled()) {
      store.dispatch(loadPublishTerms());
    }

    $rootScope.$emit('addForm.updateSegments');
  };

  return {
    isNewPublishTermsEnabled,
    getPublishTermsType,
  };
}

app.service('publishTermsService', ['store', 'config', 'httpApi', '$rootScope', publishTermsService]);
